import { useQuery } from '@tanstack/react-query'
import { getCompanies } from 'api/companies'
import { companiesKey } from './keys'

type Companies = Awaited<ReturnType<typeof getCompanies>>

export const useCompaniesQuery = (
  options?: Pick<
    Parameters<typeof useQuery<Companies, Error, Companies, string[]>>[0],
    'enabled'
  >
) => {
  return useQuery({
    queryKey: companiesKey,
    queryFn: getCompanies,
    staleTime: 1000 * 60 * 60 * 5, // 5 hours
    ...options,
  })
}
